<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Area from "@/components/c-input-area";
import Loading from "@/components/c-loading";
import { customerSalePerformanceService } from "../../../services/contactservice/customerSalePerformance.service";
import { customerService } from "../../../services/contactservice/customer.service";
import i18n from "../../../i18n";
import List from "../../../components/list";
/* eslint-disable no-console */

/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Customer Folow Up Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    Area,
    List
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Customer Folow Up",
      breadCrumb: {},

      customerSalePerformances: {},
      customer: null,
      valueCode: '',
      valueName: '',
      valueNmaeEn: '',
      valueNotation: '',
      valueInterested: 0,
      valueDescription: '',
      valueSource: '',
      valueDate: this.$moment().clone().format('YYYY-MM-DD'),
      
    };
  },
  mounted() {
  
    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } else {
      this.loadingData(0);   
    } 
  },

  methods: {
    loadingData: function(id) {
      this.fetchingStats = false;
      customerService.getOne(id)
        .then(response => {

          this.fetchingStats = true;

          if(response.data) {
            this.breadCrumb = {
              text: response.data.name + " - (" + response.data.code + ")",
              active: true,
            };

            this.customer = response;

            this.valueCode = this.customer.data.code;
            this.valueName = `${this.customer.data.name} (${this.customer.data.name_en})`;
            this.valueNameEn = this.customer.data.name_en;
            this.valueNotation = "";
            this.valueInterested = 0;
            this.valueDescription = "";
            this.valueSource = "";

            this.loadingListData(this.customer.data.id);

          }
          
        });
    },

    loadingListData: function(customerId) {

      let param = `?clause={"clause":[{"conjuction":"and","customer_sale_performances.customer_id":{"value": ${customerId}}}]}`;

      customerSalePerformanceService.getList(param)
        .then(response => {
          if(response.data) {
            this.customerSalePerformances = response;
          }
        });
    },

    submitCancel: function() {

      // console.log(this.dataType);

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "customer-list"
          });

        }
      });
      
    },
    submitSave: function() {

      if(this.valueSource == '') {
        this.$swal.fire({
          title: i18n.t('general.required.title'),
          text: i18n.t('customer.nationality') + i18n.t('general.required.message'),
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.success.yes')
        });
        return;
      }  else if(this.valueNotation == '') {
        this.$swal.fire({
          title: i18n.t('general.required.title'),
          text: i18n.t('customer.nationality') + i18n.t('general.required.message'),
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.success.yes')
        });
        return;
      } 

      this.tryingToSubmit = true;

      let customerSalePerformance = {
        customer_id: this.$route.params.id,
        source: this.valueSource,
        record_date: this.valueDate,
        notation: this.valueNotation,
        interested: this.valueInterested,
        description: this.valueDescription
      };

      // console.log(JSON.stringify(customerSalePerformance));


      customerSalePerformanceService.insert(customerSalePerformance)
        .then(response => {
          this.tryingToSubmit = false;
          if(response.status == 200) {

            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.success.yes'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (!result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "customer-list"
                });
              }else{
                location.reload();
              }
            });
          }
        
      });
      
      }
    },

    clearForm: function() {
       
      this.valueName = '';
      this.valueNameEn = '';
      this.valueNotation = '';
      this.valueInterested = 0;
      this.valueDescription = '';
      this.valueSource = ''
    }, 

    clickFastView(event) {
      console.log(event);

    }

  
};
</script>

<template>
  <Layout>
    <PageHeader :items="[{
      text: $t('customer.list'),
      href: '/general/customer',
    }, {
      text: $t('customer.follow-up.text'),
      active: true
    }]" :title="$t('customer.follow-up.text')" />
   

    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
      <div class="row">
        <div class="col-sm">
          <div class="card">
            <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <Input 
                      :type="'text'"
                      :id="'code'"
                      :disabled="true"
                      v-model="valueCode"
                      :label="'customer.code'"
                      /> 
                  </div>
                  <div class="col-md-6">
                    <Input 
                      :type="'text'"
                      :id="'name'"
                      :disabled="true"
                      v-model="valueName"
                      :require="true"
                      :label="'customer.name'"  />
                  </div>
                  
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <Input 
                      :type="'date'"
                      :id="'date'"
                      v-model="valueDate"
                      :label="'customer.follow-up.date'"  />
                  </div>
                  <div class="col-md-6">
                    <Input 
                      :type="'text'"
                      :id="'source'"
                      v-model="valueSource"
                      :label="'customer.follow-up.source'"  />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <Input 
                      :type="'number'"
                      :id="'interested'"
                      v-model="valueInterested"
                      :last="'%'"
                      :label="'customer.follow-up.interested'"  />
                  </div>
                  <div class="col-md-6">
                    <Input 
                      :type="'text'"
                      :id="'notation'"
                      v-model="valueNotation"
                      :label="'customer.follow-up.payment-method'"  />
                  </div>
                </div>
                <!-- <div class="row">
                  <div class="col-lg-12">
                    <Area 
                      :rows="5"
                      :id="'notation'"
                      v-model="valueNotation"
                      :label="'customer.follow-up.payment-method'"  />
                  </div>
                </div> -->
                <div class="row">
                  <div class="col-lg-12">
                    <Area 
                      :rows="5"
                      :id="'description'"
                      v-model="valueDescription"
                      :label="'customer.follow-up.description'"  />
                  </div>
                </div>
                

                <div class="row">
                  <div class="col-lg-12">

                    <div inline class="row gy-2 gx-3 align-items-end">
                      <div class="col-sm-auto">
                        <Button v-bind:icon="'bx bx-x-circle'" 
                          v-bind:buttonType="'button'"
                          v-bind:variant="'danger'"
                          @click="submitCancel()"
                          v-bind:title="$t('general.cancel')"  />
                      </div>
                      <div class="col-sm-auto">
                        <Button v-bind:icon="'bx bx-save bx-tada'" 
                          v-bind:buttonType="'button'"
                          @click="submitSave()"
                          v-bind:requesting="tryingToSubmit"
                          v-bind:title="$t('general.save')"  />
                      </div>
                    </div>
      
                  </div>
                </div>
            
            </div>
          </div>
        </div>

        <div class="col-sm-8">
        
          <List @view="clickFastView"
                v-bind:dataList="customerSalePerformances" 
                v-bind:filter="{}"
                v-bind:fill="false"
                v-bind:updating="true" 
                v-bind:showLoading="false"
                v-bind:navigate="pageNavigate"
                v-bind:showNo="false"
                v-bind:formats="[{name: 'description', type: 'fast-view'}, {name: 'record_date', type: 'date'}]"
                v-bind:fields="[ 
                  `record_date: ${$t('customer.follow-up.date')}`, 
                  `source: ${$t('customer.follow-up.source')}`, 
                  `interested: ${$t('customer.follow-up.interested')}`, 
                  `notation: ${$t('customer.follow-up.payment-method')}`, 
                  `description: ${$t('customer.follow-up.description')}`
                ]" 
                
          />  

        </div>
      </div>
    </b-form> 
  
  </Layout>
</template>